import { render } from "./PublicNewsDetails.vue?vue&type=template&id=4d148204"
import script from "./PublicNewsDetails.vue?vue&type=script&lang=js"
export * from "./PublicNewsDetails.vue?vue&type=script&lang=js"

import "./PublicNewsDetails.vue?vue&type=style&index=0&id=4d148204&lang=css"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
